import React from 'react';
import { History, HistoryEvent } from './History';
import KTween from '../core/KTween';
import Page from '../core/screens/Page';
import Router from './Router';

export default class ScrollRouter extends Page
{
	container:HTMLDivElement;
	history = new History();
	_scrollY = 0;
	_checkRouteTimeout;
	_replacedRoute;

	componentDidMount()
	{
		this.history.on(HistoryEvent.CHANGE, this._historyChange);
		this.history.on(HistoryEvent.REPLACE, this._historyChange);
		setTimeout(this._historyChange, 1);
		setTimeout(()=>window.addEventListener('scroll', this._onScroll), 1000);
	}

	get scrollY() { return window.scrollY };
	set scrollY(value) {
		this._scrollY = value;
		window.scrollTo(window.scrollX, this._scrollY);
	};

	private _historyChange = (e, data) => {
		console.log('>>', this.history.path);
		if(this._replacedRoute == this.history.path) return;
		let target = this.container?.querySelector('[data-path="' + this.history.path + '"]');
		if(target)
		{
			let bounds = target.getBoundingClientRect();
			let py = bounds.top + window.scrollY;
			let nav = document.querySelector('.navigation');
			if(py <= window.scrollY && window.scrollY <= py + bounds.height) return;
			if(nav)
			{
				py -= nav.getBoundingClientRect().height;
			}
			KTween.tween(this, {scrollY: py}, 'easeInOutQuart', 0.6);
		}
	}

	componentWillUnmount()
	{
		window.removeEventListener('scroll', this._onScroll);
		this.history.off(HistoryEvent.CHANGE, this._historyChange);
		this.history.off(HistoryEvent.REPLACE, this._historyChange);
		KTween.remove(this);
	}
	
	private _onScroll = (e) =>
	{
		this._checkRoute();
	}

	private _checkRoute() {
		clearTimeout(this._checkRouteTimeout);
		this._checkRouteTimeout = setTimeout(this.__checkRoute, 0);
	}

	private __checkRoute = () =>
	{
		if(!Router.routeScrollable(this.history.path)) return;
		let pages = this.container?.querySelectorAll('[data-path]');
		let minY = Number.NEGATIVE_INFINITY;
		let path = '/';
		let py = window.innerHeight * 0.5;
		pages.forEach((e)=>{
			let bounds = e.getBoundingClientRect();
			if(bounds.top > minY && bounds.top < py)
			{
				path = e.getAttribute('data-path');
				minY = bounds.top;
			}
		});
		this._replacedRoute = path;
		this.history.replace(path);
	}


	render()
	{
		return (<div className="scrollPage" ref={r => this.container = r}>{this.props.children}</div>);
	}
}